export const DEFAULT_USER_ROLE = 'none'

export const DEFAULT_HEADERS = {
	'Accept': 'application/json'
}

export const REQUEST_PATHS = {
	BASE_PATH: '/api',
	AUTH: '',
	ADMIN: 'api/admin'
}
